import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export const useAccountingReports = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState(
    searchParams.get("tab") || "trial_balance_tab",
  );

  const mainTabs = [
    {
      label: "Trial Balance",
      key: "trial_balance_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Profit or Loss",
      key: "profit_and_loss_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Balance Sheet",
      key: "balance_sheet_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Cash Flow Statement",
      key: "cash_flow_statement_tab",
      showOnLocalSetup: false,
    },
    // {
    //   label: "Ageing Payables",
    //   key: "ageing_payables_tab",
    //   showOnLocalSetup: false,
    // },
    // {
    //   label: "Ageing Receivables",
    //   key: "ageing_receivables_tab",
    //   showOnLocalSetup: false,
    // },
  ];

  const otherTabs = [
    {
      label: "Journal Report",
      key: "journal_report_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Customer Statement",
      key: "customer_statement_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Supplier Statement",
      key: "supplier_statement_tab",
      showOnLocalSetup: false,
    },
    {
      label: "VAT Summary / VAT Ledger",
      key: "vat_summary_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Bank Reconciliation Report",
      key: "bank_reconciliation_report_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Inventory Valuation Report",
      key: "inventory_valuation_report_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Audit Trail Report",
      key: "audit_trail_report_tab",
      showOnLocalSetup: false,
    },
  ];

  const updateSelectedTab = (key) => {
    setSelectedTab(key);
    const nextSearchParams = new URLSearchParams();
    nextSearchParams.set("tab", key);
    setSearchParams(nextSearchParams, { replace: true });
  };

  return {
    selectedTab,
    updateSelectedTab,
    mainTabs,
    otherTabs,
  };
};
